require('./bootstrap');
require('./console');
import 'bootstrap';

// plugins
import 'jquery-mask-plugin/dist/jquery.mask.min';
import '@rateyo/jquery/lib/es/jquery.rateyo';
import 'bootstrap-select';
import 'bootstrap-select/js/i18n/defaults-pt_BR';
import 'slick-carousel';
import swal from 'sweetalert2';
import Player from '@vimeo/player';
import GreenAudioPlayer from 'green-audio-player';

import 'bootstrap-fileinput/js/plugins/piexif';
import 'bootstrap-fileinput/js/plugins/sortable';
import 'bootstrap-fileinput/js/fileinput';
import 'bootstrap-fileinput/js/locales/pt-BR';
import 'bootstrap-fileinput/themes/fas/theme';

import route from 'ziggy';
import {
    Ziggy
} from '../../../js/ziggy';
import {drop, isEmpty} from 'lodash';
import './filter';
import './criarCurso';
import './ckeditor';
import './classes/componentePaginacao';

window.PDFObject = require('pdfobject');
window.feather = require("feather-icons");
window.swal = swal;

window.uniModalOpen = (type, title, text, titletBtn, handleButtonClick) => {
    var titleModal = $('#modalTitleUniSm');
    var textModal = $('#modalTextUniSm');
    var btnModal = $('#modalBtnUniSm');

    if(!isEmpty(title)) {
        titleModal.text(title);
        titleModal.show();
    }

    if(!isEmpty(text)) {
        textModal.html(text);
        textModal.show();
    }

    if(!isEmpty(titletBtn)) {
        btnModal.text(titletBtn)
        btnModal.css('display', 'block');
    } else {
        btnModal.css('display', 'none');
    }

    if(typeof handleButtonClick === 'function') {
        $('#modalBtnUniSm').on('click', handleButtonClick);
    }

    switch (type) {
        case 'L':
            $('#modalImgLoadingUni').css('display', 'block');
            $('#modalIconSuccessUni').css('display', 'none');
            $('#modalIconErrorUni').css('display', 'none');
            $('#modalIconWarningUni').css('display', 'none');
            $('#modalIconDeviceResetUni').css('display', 'none');
            break;
        case 'S':
            $('#modalIconSuccessUni').css('display', 'block');
            $('#modalIconErrorUni').css('display', 'none');
            $('#modalIconWarningUni').css('display', 'none');
            $('#modalImgLoadingUni').css('display', 'none');
            $('#modalIconDeviceResetUni').css('display', 'none');
            break;
        case 'E':
            $('#modalIconErrorUni').css('display', 'block');
            $('#modalIconSuccessUni').css('display', 'none');
            $('#modalIconWarningUni').css('display', 'none');
            $('#modalImgLoadingUni').css('display', 'none');
            $('#modalIconDeviceResetUni').css('display', 'none');
            break;
        case 'W':
            $('#modalIconWarningUni').css('display', 'block');
            $('#modalIconSuccessUni').css('display', 'none');
            $('#modalIconErrorUni').css('display', 'none');
            $('#modalImgLoadingUni').css('display', 'none');
            $('#modalIconDeviceResetUni').css('display', 'none');
            break;
        case 'D':
            $('#modalIconDeviceResetUni').css('display', 'block');
            $('#modalIconWarningUni').css('display', 'none');
            $('#modalIconSuccessUni').css('display', 'none');
            $('#modalIconErrorUni').css('display', 'none');
            $('#modalImgLoadingUni').css('display', 'none');
            break;
        default:
           break;
    }

    $('#modalUniSm').modal('show');
}
window.uniModalClose = (reload) => {
    if(reload) location.reload();
    $('#modalUniSm').modal('hide');
    var titleModal = $('#modalTitleUniSm');
    var textModal = $('#modalTextUniSm');
    var btnModal = $('#modalBtnUniSm');

    $('#modalIconWarningUni').css('display', 'none');
    $('#modalIconSuccessUni').css('display', 'none');
    $('#modalIconErrorUni').css('display', 'none');
    $('#modalImgLoadingUni').css('display', 'none');
    titleModal.css('display', 'none');
    textModal.css('display', 'none');
    btnModal.css('display', 'none');

    $('#modalBtnUniSm').off('click', function(){});

    titleModal.empty();
    textModal.empty();
    btnModal.empty();
}

window.uniTwoModalOpen = (type, title, description, titletBtnTwo, handleButtonClick, handleCancelClick) => {
    var titleModal = $('#modalTwoTitleUniSm');
    var textModal = $('#modalTwoTextUniSm');
    var btnModal = $('#modalTwoBtnUniSm');

    if(!isEmpty(title)) {
        titleModal.text(title);
    } else {
        uniModalOpen(
            'E',
            'Erro ao chamar modal',
            'Faltou informar o parametro title para uniTwoModalOpen.',
            'Fechar',
            function () {
                uniModalClose();
            },
        );
        return;
    }
    if(!isEmpty(description)) {
        textModal.html(description);
    } else {
        uniModalOpen(
            'E',
            'Erro ao chamar modal',
            'Faltou informar o parametro description para uniTwoModalOpen.',
            'Fechar',
            function () {
                uniModalClose();
            },
        );
        return;
    }
    if(!isEmpty(titletBtnTwo)) {
        btnModal.text(titletBtnTwo);
    } else {
        uniModalOpen(
            'E',
            'Erro ao chamar modal',
            'Faltou informar o parametro title button para uniTwoModalOpen.',
            'Fechar',
            function () {
                uniModalClose();
            },
        );
        return;
    }
    if(typeof handleButtonClick === 'function') {
        $('#modalTwoBtnUniSm').unbind().on('click', handleButtonClick);
    }

    if(typeof handleCancelClick === 'function') {
        $('#modalCancelBtnUniSm').unbind().on('click', handleCancelClick);
    }

    switch (type) {
        case 'PR':
            $('#modalIconPersonRemove').removeClass('d-none');
            break;
        case 'GR':
            $('#modalIconGroupRemove').removeClass('d-none');
            break;
        case 'AR':
            $('#modalIconGroupRemoveAll').removeClass('d-none');
            break;
        case 'PA':
            $('#modalIconPersonAdd').removeClass('d-none');
            break;
        case 'GA':
            $('#modalIconGroupAdd').removeClass('d-none');
            break;
        case 'DF':
            $('#modalIconDeleteForever').removeClass('d-none');
            break;
        case 'DE':
            $('#modalIconDeleteError').removeClass('d-none');
            break;
        case 'D':
            $('#modalIconDelete').removeClass('d-none');
            break;
    }

    $('#modalTwoUniSm').modal('show');
}
window.uniTwoModalClose = () => {
    $('#modalTwoUniSm').modal('hide');
    $('#modalIconPersonRemove').addClass('d-none');
    $('#modalIconGroupRemove').addClass('d-none');
    $('#modalIconGroupRemoveAll').addClass('d-none');
    $('#modalIconPersonAdd').addClass('d-none');
    $('#modalIconGroupAdd').addClass('d-none');
    $('#modalIconDeleteForever').addClass('d-none');
    $('#modalIconDeleteError').addClass('d-none');
    $('#modalIconDelete').addClass('d-none');
    $('#modalTwoTitleUniSm').empty();
    $('#modalTwoTextUniSm').empty();
    $('#modalTwoBtnUniSm').empty();
    $('#modalTwoBtnUniSm').off('click', function(){});
}

document.addEventListener('DOMContentLoaded', function() {
    document.body.style.visibility = 'visible';
});

window.initializatorAudioUni = (seletor) => {
    window.audioPlayer = GreenAudioPlayer.init({
        selector: seletor,
        stopOthersOnPlay: true,
        volumeControlPosition: 'top',
    });
}

axios.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      if (error.response && error.response.status === 401 || error.response.status === 419) {
        $('.modal').modal('hide');

        uniModalOpen(
            'D', // type modal
            'Sessão expirada', // title modal
            'Para continuar, clique no botão abaixo e faça login novamente.', // text body modal
            'Entrar', // text button
        );

        document.querySelector('#modalBtnUniSm').addEventListener('click', function(){
            window.location.reload();
        });
      } else if (error.response && error.response.status === 511) {
        Swal.fire(
            'Erro de Sessão',
            'Você precisa realizar login novamente para continuar!',
            'error'
        ).then(function(){
            window.location.reload()
        });
      }

      return Promise.reject(error);
    }
);

// inicio funcoes modal de notificações
// define o estilo do modal
window.darkModeHeader = (value) => {
        if (value) {
            // header
            $("#notification_header").addClass('header-notifications-dark');
            $("#notification_header").removeClass('bg-degrade');

            // body
            $('.modal-dialog-sm').addClass('modal-content-dark');

            $('.dropdown-more-actions-notifications').addClass('modal-content-dark');
        } else {
            // header
            $("#notification_header").addClass('bg-degrade');
            $("#notification_header").removeClass('header-notifications-dark');

            // body
            $('.modal-dialog-sm').removeClass('modal-content-dark');

            $('.dropdown-more-actions-notifications').removeClass('modal-content-dark');
        }
}
window.darkModeLogin = (value) => {
    const logoUni = `${window.location.origin}/assets/public/img/login/uni-voalle-${value ? 'escuro' : 'claro'}.svg`;
    const logoVoalle = `${window.location.origin}/assets/public/img/login/grupo-voalle-logo-${value ? 'escuro' : 'claro'}.svg`;
    const logoUniPequeno = `${window.location.origin}/assets/public/img/login/uni-voalle-logo-${value ? 'escuro' : 'claro'}.svg`;

    $("#img-logo-uni-login").attr("src", logoUni);
    $("#logo-grupo-voalle").attr("src", logoVoalle);
    $("#logo-uni-voalle").attr("src", logoUniPequeno);
};

// chamado quando usuario clicou no botão de notificações
$('#notificationMenuButton').click(function (){
    window.countVerMais = 1;
    // altera o filtro selecionado
    $('#notificatiosAll').addClass('option-body-active');
    $('#notificatiosNotRead').removeClass('option-body-active');

    // Criar pesquisa para todas as notificações
    axios.get(route(`usuarios.painel.notifications.allNotifications`, { page: window.countVerMais }, undefined, Ziggy))
    .then(function (response) {
        if (response.status) {
            var notifications = response.data.notifications.data;
            populaNotifications(notifications, response.data.notifications.total);
        }
    });

    // remove classe que aplica efeito no fechamento do modal
    $('#notificationModal').removeClass('hide');
    // add classe animacao e exibe modal
    $('#notificationModal').modal('show');
});

//           funções do botão de mais ações
// função para marcar todas como as notificações como lidas
$('#markReadAllNotifications').click(()=>{
    // chama rota que marca todas as notificações como lidas
    axios.patch(route(`usuarios.painel.notifications.markReadNotifications`, undefined, undefined, Ziggy));

    // remove o estilo não lidas e adiciona lidas
    $('#count-notifications').addClass('d-none');
    let iconNaoLidas = $(`.icon-body-notifications.item-notification`);
    iconNaoLidas.addClass('icon-body-notifications-read');

    let naoLidas = $('.text-not-read');
    naoLidas.addClass('text-read');

    $('.circle-blue').hide();
});
// função que deleta todas as notificações
$('#deleteAllNotifications').click(()=>{
    // faz requisição para excluir as notificações
    axios.delete(route(`usuarios.painel.notifications.deleteNotifications`, undefined, undefined, Ziggy));

    // esconde todos os elementos
    $('#newNotificationsTitle').addClass('d-none');
    $('#newNotifications').empty();
    $('#lastNotificationsTitle').addClass('d-none');
    $('#lastNotifications').empty();
    $('#verMaisNotifications').addClass('d-none');
    $('#count-notifications').addClass('d-none');
    $('#noneNotifications').removeClass('d-none');

    $('#newCentralNotificationsTitle').addClass('d-none');
    $('#newCentralNotifications').empty();
    $('#lastCentralNotificationsTitle').addClass('d-none');
    $('#lastCentralNotifications').empty();
    $('#verMaisCentralNotifications').addClass('d-none');
    $('#count-notifications').addClass('d-none');
    $('#noneCentralNotifications').removeClass('d-none');
});

// função chamada ao clicar no submenu todas
var allTime = 0;
$('#notificatiosAll').click(()=>{

    if (Date.now() - allTime < 1000) {
        return; // Ignora o clique
    }

    allTime = Date.now(); // Atualiza o horário do último clique

    window.countVerMais = 1;
    $('#newNotificationsTitle').addClass('d-none');
    $('#lastNotificationsTitle').addClass('d-none');
    // pega a div e esvazia a div
    $('#newNotifications').empty();
    // pega a div e esvazia a div
    $('#lastNotifications').empty();
    // altera o filtro selecionado
    $('#notificatiosNotRead').removeClass('option-body-active');
    $('#notificatiosAll').addClass('option-body-active');
    // esconde botão de ver mais
    $('#verMaisNotifications').addClass('d-none');

    // Criar pesquisa para todas as notificações
    axios.get(route(`usuarios.painel.notifications.allNotifications`, { page: window.countVerMais }, undefined, Ziggy))
    .then(function (response) {
        if (response.status) {
            var notifications = response.data.notifications.data;
            populaNotifications(notifications, response.data.notifications.total);
        }
    });
});
// função chamada ao clicar no submenu não lidas
var notReadTime = 0;
$('#notificatiosNotRead').click(()=>{

    if (Date.now() - notReadTime < 1000) {
        return; // Ignora o clique
    }

    notReadTime = Date.now(); // Atualiza o horário do último clique

    window.countVerMais = 1;
    $('#newNotificationsTitle').addClass('d-none');
    $('#lastNotificationsTitle').addClass('d-none');
    // pega a div e esvazia a div
    $('#newNotifications').empty();
    // pega a div e esvazia a div
    $('#lastNotifications').empty();
    // altera o filtro selecionado
    $('#notificatiosNotRead').addClass('option-body-active');
    $('#notificatiosAll').removeClass('option-body-active');
    // esconde botão de ver mais
    $('#verMaisNotifications').addClass('d-none');

   // Criar pesquisa para as notificações não lidas
   axios.get(route(`usuarios.painel.notifications.notReadNotifications`, { page: window.countVerMais }, undefined, Ziggy))
   .then(function (response) {
       if (response.status) {
           var notifications = response.data.notifications.data;
           populaNotifications(notifications, response.data.notifications.total);
       }
   });
});

$('#moreNotifications').click(()=>{
    window.countVerMais++;
    if($('#notificatiosAll').hasClass('option-body-active')){
        // Criar pesquisa para todas as notificações
        axios.get(route(`usuarios.painel.notifications.allNotifications`, { page: window.countVerMais }, undefined, Ziggy))
        .then(function (response) {
            if (response.status) {
                var notifications = response.data.notifications.data;
                populaNotifications(notifications, response.data.notifications.total);
            }
        });
    } else {
        // Criar pesquisa para as notificações não lidas
        axios.get(route(`usuarios.painel.notifications.notReadNotifications`, { page: window.countVerMais }, undefined, Ziggy))
        .then(function (response) {
        if (response.status) {
                var notifications = response.data.notifications.data;
                populaNotifications(notifications, response.data.notifications.total);
            }
        });
    }
});

function populaNotifications(notifications, total){
    notifications = (notifications && Array.isArray(notifications)) ? notifications : Object.values(notifications);
    // verifica se existem notificações
    if(notifications.length > 0) {
        // pega as divs novas e anteriores, respectivamente
        let newNotifications = $('#newNotifications');
        let lastNotifications = $('#lastNotifications');
        var dataAtual = new Date();
        // laço de repetição
        notifications.forEach((notification) => {
            // verifica se é nova < 1 ou anterior
            if(((dataAtual - new Date(notification.created_at)) / 86400000) < 1){
                // popula a div novas
                newNotifications.append(`
                    <a class="item-list-notifications m-0 p-0" href="${notification.href}">
                        <div class="text-body-central-notifications">
                            <div
                                class="d-flex justify-content-center align-items-center icon-body-notifications item-notification ${notification.read_at ? 'icon-body-notifications-read' : '' }"
                                style="background: ${notification.cor}15;"
                            >
                                <span class="material-symbols-outlined" style="color: ${notification.cor};">${notification.icone}</span>
                            </div>
                            <div class="w-100 uni-body-medium text-not-read ${ notification.read_at ? 'text-read' : '' } overflow-x-body-central-notification">
                                ${JSON.parse(notification.data).conteudo}
                            </div>
                            <div class="uni-body-medium text-not-read ${ notification.read_at ? 'text-read' : '' } text-right d-flex flex-row align-items-center justify-content-end">
                                ${notification.diff}
                                ${notification.read_at ? '' : `<div class="circle-blue"></div>`}
                            </div>
                        </div>
                    </a>
                `);
            } else {
                // popula a div anteriores
                lastNotifications.append(`
                    <a class="item-list-notifications m-0 p-0" href="${notification.href}">
                        <div class="text-body-central-notifications">
                            <div
                                class="d-flex justify-content-center align-items-center icon-body-notifications item-notification ${notification.read_at ? 'icon-body-notifications-read' : '' }"
                                style="background: ${notification.cor}15;"
                            >
                                <span class="material-symbols-outlined" style="color: ${notification.cor};">${notification.icone}</span>
                            </div>
                            <div class="w-100 uni-body-medium text-not-read ${ notification.read_at ? 'text-read' : '' } overflow-x-body-central-notification">
                                ${JSON.parse(notification.data).conteudo}
                            </div>
                            <div class="uni-body-medium text-not-read ${ notification.read_at ? 'text-read' : '' } text-right d-flex flex-row align-items-center justify-content-end">
                                ${notification.diff}
                                ${notification.read_at ? '' : `<div class="circle-blue"></div>`}
                            </div>
                        </div>
                    </a>
                `);
            }
        });

        // exibe as div's se tiver conteudo
        if(newNotifications.html() != ''){
            $('#noneNotifications').addClass('d-none');
            $('#newNotificationsTitle').removeClass('d-none');
            newNotifications.removeClass('d-none');
        }

        // exibe as div's se tiver conteudo
        if(lastNotifications.html() != ''){
            $('#noneNotifications').addClass('d-none');
            $('#lastNotificationsTitle').removeClass('d-none');
            lastNotifications.removeClass('d-none');
        }

        // cria verificacao para exibir botao ver mais
        if(total > (10 * window.countVerMais)) {
            // remove a classe display none
            $('#verMaisNotifications').removeClass('d-none');
        } else {
            // add a classe display none
            $('#verMaisNotifications').addClass('d-none');
            // reseta o contador
            window.countVerMais = 1;
        }
    } else {
        // se não houver habilitar
        window.darkMode == 1 ? $('#noneNotifications').addClass('text-white') : $('#noneNotifications').removeClass('text-white');
        $('#verMaisNotifications').addClass('d-none');
        $('#noneNotifications').removeClass('d-none');
    }
};

$('#buttomExitModal').on('click', function() {
    $('#notificationModal').addClass('hide');
    setTimeout(()=>{$('#notificationModal').modal('hide')}, 600);
});

document.addEventListener('click', function(event) {
    if ($(event.target).hasClass('right')) {
        $('#notificationModal').addClass('hide');
        setTimeout(()=>{$('#notificationModal').modal('hide')}, 600);
    }
});

// evento chamado ao finalizar o fechamento do modal
$('#notificationModal').on('hidden.bs.modal', (e)=>{
    // pega a div e esvazia a div
    $('#newNotifications').empty();
    // pega a div e esvazia a div
    $('#lastNotifications').empty();
});
// fim funcoes modal de notificações
window.getQuizAva = function (itemid,aulaid){

    axios.post(route("ajax.gamificacao.avaliacao_verificacao.acessar",undefined, undefined, Ziggy),{itemid:itemid} )
    .then(function(response){
        var obj = response.data.data;
        let respondeu = false;
        if(response.status === 200){
            if(obj != null && obj.enunciado != null && obj.enunciado.length > 0 && obj.alternativas != null){
                $("#AVuserModalToggle").modal("show");
                if(document.getElementById("bxAVuserModalToggle") != null){
                $("#bxAVuserModalToggle").html('<div class="w-100"> <div class="w-100" id="bx-ava-verif"></div> </div>');
                $("#bx-ava-verif").append('<div class="tituloQuestaoAv uni-title-medium">'+obj.enunciado.charAt(0).toUpperCase() + obj.enunciado.slice(1)+'</div>');
                var alternativas = JSON.parse(obj.alternativas);
                var resposta = JSON.parse(obj.respostas);

                $("#bx-ava-verif").append('<div class="w-100 py-3" id="alternativas_ava_verif_'+obj.id+'"></div>');
                alternativas.forEach((i)=>{
                    $("#alternativas_ava_verif_"+obj.id).append(`
                        <div style="padding:8px" class="div-alternativa d-flex justify-content-between mt-2" data-id="`+i.id+`">
                            <div class="form-check">
                                <input class="form-check-input input-radio-av-verificacao" type="radio" name="QO1" id="rdAnswerQO1AV_`+i.id+`" value="`+i.conteudo+`" data-id="`+i.id+`" data-av="`+ obj.id +`">
                                <label class="form-check-label pl-2" for="rdAnswerQO1AV_`+i.id+`" id="lablrdAnswerQO1AV_`+i.id+`">
                                    <p class="mb-0 alternsQuizAv uni-title-medium">
                                        `+i.conteudo+`
                                    </p>
                                </label>
                            </div>
                            <img class="d-none icon-certa-resposta" data-id="`+i.id+`" src="" alt="">
                            <img class="d-none icon-errada-resposta" data-id="`+i.id+`" src="" alt="">
                        </div>`);
                });

                $("#btnsavefooterAV").html('<div class="" id="bx-respostaAV"><button class="uni-btn uni-btn-filled disabled-filled ml-2" style="text-transform: none;float: right;" type="button"  id="sendAvaVer_'+obj.id+'" data-resposta="'+resposta[0].id+'">Enviar</button></div> ');

                // evento do botão de enviar resposta da avaliação
                document.getElementById("sendAvaVer_"+obj.id).addEventListener('click',(el)=>{
                    var dt = el.target.dataset;
                    var id_resposta = dt.resposta;
                    var inputs = document.getElementsByClassName("form-check-input");
                    var elms = Array.prototype.slice.call(inputs);
                    var pontua = 'nao-respondido'; var alternativa
                    elms.forEach((i,c)=>{
                        if(i.checked == true && i.id == 'rdAnswerQO1AV_'+id_resposta){
                            pontua = true; alternativa = i.dataset.id;
                        }else if(i.checked == true && i.id != 'rdAnswerQO1AV_'+id_resposta){
                            alternativa = i.dataset.id; pontua = false;
                        }

                        if(elms.length == (c+1)){

                            //desabilita inputs
                            $('.input-radio-av-verificacao').prop("disabled", true);

                            if(pontua == true){
                                // atualiza modal de retorno em tempo real
                                $(".AVuserModalToggleLabel").text('').append(`<span class="uni-title-large">Parabéns!</spanclass> <span class="uni-title-large" style="font-weight: 500 !important">🎉 Você acertou! 🌟</span>`);
                                $(".btns-pular-save").addClass("d-none");
                                $(".btn-proxima-aula").removeClass("d-none").addClass("d-flex");
                                $(".alternativa-selecionada").removeClass("alternativa-selecionada").addClass("resposta-certa-verificacao");
                                $('.icon-certa-resposta[data-id='+ alternativa +']').removeClass('d-none');
                                $('.icon-certa-resposta[data-id='+ alternativa +']').prop("src", `${window.location.origin}/assets/public/img/resposta-certa-verificacao.svg`);
                                $('.input-radio-av-verificacao[data-id='+ alternativa +']').prop("disabled", false);
                                $('.input-radio-av-verificacao[data-id='+ alternativa +']').addClass("resposta-certa");

                            }else if(pontua == false){
                                // atualiza modal de retorno em tempo real
                                $(".AVuserModalToggleLabel").text('').append(`<span class="uni-title-large">Infelizmente,</span> <span class="uni-title-large" style="font-weight: 500 !important"> você não acertou 😔</span>`);
                                $(".btns-pular-save").addClass("d-none");
                                $(".btn-proxima-aula").removeClass("d-none").addClass("d-flex");
                                $('.icon-errada-resposta[data-id='+ alternativa +']').removeClass('d-none');
                                $('.icon-errada-resposta[data-id='+ alternativa +']').prop("src", `${window.location.origin}/assets/public/img/resposta-errada-verificacao.svg`);
                                $(".alternativa-selecionada").removeClass("alternativa-selecionada").addClass("resposta-errada-verificacao");

                                $('.icon-certa-resposta[data-id='+ id_resposta +']').removeClass('d-none');
                                $('.icon-certa-resposta[data-id='+ id_resposta +']').prop("src", `${window.location.origin}/assets/public/img/resposta-certa-verificacao.svg`);
                                $('.input-radio-av-verificacao[data-id='+ alternativa +']').prop("disabled", false);
                                $('.input-radio-av-verificacao[data-id='+ alternativa +']').addClass("resposta-errada");
                                $('.div-alternativa[data-id=' + id_resposta + ']').addClass('resposta-certa-verificacao');
                            }

                            if(pontua == true || pontua == false){
                                // seta questionario como respondido e pontua se usuário respondeu corretamente
                                axios.post(route("ajax.gamificacao.avaliacao_verificacao.responder",undefined, undefined, Ziggy),{itemid:itemid,resposta:alternativa} )
                                .then(function(response){
                                    if(response.status === 200){
                                        if(response.data.data == true){
                                            // pontuar se acertou a alternativa
                                            if(pontua == true){
                                                notificationAvatarGamificadoPontuou(10);
                                                axios.post(route("ajax.gamificacao.pontuar.PontuaResponderAV'",undefined, undefined, Ziggy),{'id_recurso':aulaid} )
                                                .then(function(response){
                                                    if(response.status === 200){
                                                       // console.log('foi pontuado ao responder avaliação de verificação')
                                                    }
                                                }).catch(function(error){
                                                   // console.error('não foi possivel pontuar ao responder avaliação de verificação')
                                                })
                                            }
                                        }
                                    }
                                }).catch(function(error){
                                    console.error('não foi possivel gravar resposta da avaliação de verificação')
                                })

                                respondeu = true;
                            }
                        }
                    });
                },false)


                $("#btnpularfooterAv").html('<button type="button" class="uni-btn uni-btn-text btnpularAV pular" data-dismiss="modal" style="float:left;">Pular</button>')
                // evento de pular questionário (não responder), registra que ele pulou
                var elmsPularQuiz = document.getElementsByClassName("btnpularAV");
                var arrElmsPularQuiz = Array.prototype.slice.call(elmsPularQuiz);
                arrElmsPularQuiz.forEach((ibp)=>{
                    ibp.addEventListener('click',(el)=>{
                        axios.post(route("ajax.gamificacao.avaliacao_verificacao.responder",undefined, undefined, Ziggy),{itemid:itemid,resposta:0} )

                        if(respondeu){
                            $('#proxAula').prop("href", document.getElementById("btnproxAulafooterAV").href);
                        }
                        if(el.target.classList.contains('pular')){
                            var href = document.getElementById("btnproxAulafooterAV").href;
                            window.location.href = href;
                        }
                    },false);
                });
                }
            }else{
                var href = document.getElementById("btnproxAulafooterAV").href;
                window.location.href = href;
            }
        }
    })
}

$(document).on('change', '.input-radio-av-verificacao', function(){
    let id = $(this).data('id');
    let idAvaliacao = $(this).data('av');
    $('.div-alternativa').removeClass('alternativa-selecionada');
    $('.div-alternativa[data-id=' + id + ']').addClass('alternativa-selecionada');
    $('#sendAvaVer_'+ idAvaliacao).removeClass('disabled-filled');
})

window.btn_show = function (i,c=0){
    var el = document.getElementById(i)
    var elDisplay = el.style.display;
    if(c != 0){
        var elms = document.querySelectorAll('.'+c);
        elms.forEach((x)=>{
            x.style.display = 'none';
            if(x == el){
                if(elDisplay == 'none'){
                    el.style.display = 'block';
                }else if(elDisplay == 'block'){
                    el.style.display = 'none';
                }
            }
        });
    }else{
        if(elDisplay == 'none'){
            el.style.display = 'block';
        }else if(elDisplay == 'block'){
            el.style.display = 'none';
        }
    }
}

window.concluirInteracaoTutorial = function(interacao){
    axios.post(route("ajax.gamificacao.set.visto", {
        interacao: interacao
    }, undefined, Ziggy))
    .then(function(response){
        if(response.status === 200){

        }
    }).catch(function(error){

    })
}

// Cria função global que adiciona uma vairiavel em cache para cada video
window.criaVarTempo = function(id){
    // chama a rota que pontua por assistir integralmente o video
    localStorage.setItem(`inicio-video-${id}`, new Date().getTime());
}

// Cria Função Global que verifica se o usuário assistiu pelo menos 90% do video
window.verificaTempoUserVideo = function(id){
    // faz o calculo do tempo que o usuário assistiu o video
    var timeUserInVideo = (new Date().getTime() - localStorage.getItem(`inicio-video-${id}`)) / 1000;
    // retorna verdadeiro se o tempo assistido for igual ou maior a 90% do tempo do video
    return (parseFloat(timeUserInVideo) >= (localStorage.getItem(`video-${id}-duration`) * 0.89));
}

// Cria função global para pontuar por assistir completamente o video
window.pontuaAssistirVideoCompleto = function(id){
    return axios.post(
        route('ajax.gamificacao.pontuar.PontuaAssistirRecursoVideo'),
        {'id_recurso': id},
        undefined,
        Ziggy
        ).then(function(response){
            if(response.status === 200){
                if(response.data == true){
                    notificationAvatarGamificadoPontuou(10);
                }
                localStorage.removeItem(`video-${id}-duration`);
                localStorage.removeItem(`inicio-video-${id}`);
            }
    });
}

function verificarAcessoCertificado() {
    let cert = jQuery("#hddCMACERT").val();
    if (cert === "T") {
        axios.post(route("ajax.acesso.certificado", {
                cursopessoasid: jQuery("#hddCPI").val()
            }, undefined, Ziggy))
            .then(function (response) {
                if (response.data.acesso) {
                    $('#mostraCertificado').removeClass('no-click2');
                    $('#mostraCertificado').off();
                }
            });
    }

}

function checkAula() {
    jQuery('#proxAula').removeClass('desabilitado');
    jQuery('.btn-certificado').removeClass('desabilitado');
    let modAula = jQuery("#hddCMAI").val();
    let mod = jQuery("#hddCMI").val();
    if (jQuery(`#aulacheck-${modAula}`).hasClass('text-primary')) {
        return false;
    }

    $(`#aulacheck-${modAula}`).text('check_circle').removeClass('text-black').addClass('text-primary');
    let progressoTotal = parseInt($('#progressototal').val()) + 1;
    let totalProgredir = parseInt($('#totalaconcluirprogresso').val());
    $('#progressototal').html(progressoTotal);
    let porcentagemProgresso;
    if (totalProgredir === 0) {
        porcentagemProgresso = 0; // ou defina um valor padrão que faça sentido para o seu caso
    } else {
        porcentagemProgresso = (progressoTotal / totalProgredir) * 100;
    }
    porcentagemProgresso = Math.min(porcentagemProgresso, 100);
    if($('#hddCertificado').val()){
        $('.progresso1 .progress-bar.bg-degrade').css("width", porcentagemProgresso + "%");
        $('#porcentagemProgresso').html(Math.round(porcentagemProgresso) + '%');
    }

    let aula = parseInt(jQuery(`#modAulaNV-${mod}`).html()) + 1;
    if (parseInt(jQuery(`#modAulaTot-${mod}`).html()) >= aula) {
        jQuery(`#modAulaNV-${mod}`).html(aula);
    }
}

function excluirComentario() {
    jQuery('.excluirComentario').off();
    jQuery('.excluirComentario').click(function () {
        let idComentario = $(this).attr('id');
        swalWithBootstrapButtons.fire({
            title: 'Você tem certeza?',
            text: "",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Remover',
            cancelButtonText: 'Cancelar',
            focusConfirm: false,
            focusCancel: true,
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(route("ajax.comentario.excluir", {
                        aulaid: jQuery("#hddCMAI").val(),
                        userid: jQuery("#hddUID").val(),
                        comentarioid: idComentario
                    }, undefined, Ziggy))
                    .then(function (response) {
                        if (response && response.status == 200 && response.data && response.data.status) {
                            jQuery("#idcomentario-" + idComentario).remove();
                            let val = parseInt($('#numComentAulas').html());
                            $('#numComentAulas').html(--val);
                            swalWithBootstrapButtons.fire({
                                text: response.data.message,
                                icon: 'success'
                            });
                        } else if (response && response.data && response.data.message) {
                            swalWithBootstrapButtons.fire({
                                text: response.data.message,
                                icon: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        swalWithBootstrapButtons.fire({
                            text: error.message,
                            icon: 'error',
                        });
                    });
            }
        });

    });
}

function refazerAvaliacao() {
    jQuery("#refazerAvaliacao").click(function () {
        jQuery("#refazerAvaliacao").attr("disabled", "disabled");
        jQuery("#proximaAula").attr("disabled", "disabled");
        axios.post(route("ajax.prova.refazer", undefined, undefined, Ziggy), {
                cpi: jQuery("#hddCPI").val(),
                cmi: jQuery("#hddCMI").val(),
                cmai: jQuery("#hddCMAI").val(),
                ci: jQuery("#hddCI").val(),
            })
            .then(function (response) {
                if (response && response.status == 200 && response.data && response.data.status) {
                    window.location.reload(true);
                } else {
                    jQuery("#refazerAvaliacao").removeAttr("disabled");
                    jQuery("#proximaAula").removeAttr("disabled");
                }
            })
            .catch(function (error) {
                jQuery("#refazerAvaliacao").removeAttr("disabled");
                jQuery("#proximaAula").removeAttr("disabled");

                console.error("REF_AVA", error);
                swalWithBootstrapButtons.fire({
                    text: error.message,
                    icon: 'error',
                });
            });
    });
}

function refazerAvaliacaoCorrecao() {
    jQuery("#refazerAvaliacaoCorrecao").click(function () {
        swalWithBootstrapButtons.fire({
            title: 'Você tem certeza?',
            text: "Ao clicar em refazer você estará abrindo mão de sua avaliação não corrigida.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Refazer',
            cancelButtonText: 'Cancelar',
            focusConfirm: false,
            focusCancel: true,
        }).then((result) => {
            if (result.isConfirmed) {
                jQuery("#refazerAvaliacaoCorrecao").attr("disabled", "disabled");
                jQuery("#proximaAula").attr("disabled", "disabled");
                axios.post(route("ajax.prova.refazer", undefined, undefined, Ziggy), {
                        cpi: jQuery("#hddCPI").val(),
                        cmi: jQuery("#hddCMI").val(),
                        cmai: jQuery("#hddCMAI").val(),
                        ci: jQuery("#hddCI").val(),
                    })
                    .then(function (response) {
                        if (response && response.status == 200 && response.data && response.data.status == 1) {
                            window.location.href = window.location.href;
                        } else if (response && response.status == 200 && response.data && response.data.status == 2) {
                            swalWithBootstrapButtons.fire({
                                text: "O instrutor está corrigindo sua prova, por favor aguarde.",
                                icon: 'info',
                            });
                        } else {
                            jQuery("#refazerAvaliacaoCorrecao").removeAttr("disabled");
                            jQuery("#proximaAula").removeAttr("disabled");
                        }
                    })
                    .catch(function (error) {
                        jQuery("#refazerAvaliacaoCorrecao").removeAttr("disabled");
                        jQuery("#proximaAula").removeAttr("disabled");

                        console.error("REF_AVA", error);
                        swalWithBootstrapButtons.fire({
                            text: error.message,
                            icon: 'error',
                        });
                    });
            }
        });
    });
}

jQuery(document).ready(function () {
    jQuery.fn.selectpicker.Constructor.BootstrapVersion = '4';

    jQuery('.mask-date').mask('11/11/1111');
    jQuery('.mask-time').mask('00:00:00');
    jQuery('.mask-cep').mask('00000-000');
    jQuery('.mask-phone').mask('(00) 0 0000-0000');
    jQuery('.mask-cpf').mask('000.000.000-00', {
        reverse: true
    });
    jQuery('.mask-cnpj').mask('00.000.000/0000-00', {
        reverse: true
    });
    jQuery('.mask-money').mask('000.000.000.000.000,00', {
        reverse: true
    });

    window.countVerMais = 1;
    window.darkModeHeader(window.darkMode);
    window.darkModeLogin(window.darkMode)

    let options = {
        onKeyPress: function (cpf, ev, el, op) {
            let masks = ['000.000.000-000', '00.000.000/0000-00'];
            jQuery('.cpfOuCnpj').mask((cpf.length > 14) ? masks[1] : masks[0], op);
        }
    }
    let inputCPFCNPJ = jQuery('.cpfOuCnpj');
    inputCPFCNPJ.length > 11 ? inputCPFCNPJ.mask('00.000.000/0000-00', options) : inputCPFCNPJ.mask('000.000.000-00#', options);

    jQuery(document).on('click', '.toggle-password', function () {
        let icone = jQuery(this).find('span').text();
        if(icone == "visibility"){
            jQuery(this).find('span').text("visibility_off");
        }else{
            jQuery(this).find('span').text("visibility");
        }
        let input = jQuery(this).parent("#show_hide_password").find("input");
        input.attr('type') === 'password' ? input.attr('type', 'text') : input.attr('type', 'password')
    });

    jQuery('.banners').slick({
        dots: true,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 2000,
    });

    jQuery('.calendario-lista').slick({
        infinite: false,
        arrows: false,
        speed: 300,
        dots: true,
        slidesToShow: 5,
        slidesToScroll: 2,
        responsive: [{
                breakpoint: 1367,
                settings: {
                    dots: true,
                    slidesToShow: 5,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 800,
                settings: {
                    dots: true,
                    slidesToShow: 3,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 580,
                settings: {
                    dots: true,
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });

    jQuery('.carousel-destaque').slick({
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 10000,
        speed: 500,
        slidesToScroll: 1,
        slidesToShow: 3,
        dots: true,
        responsive: [{
                breakpoint: 1110,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                }
            }
        ]
    });

    jQuery('.carousel-slick').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [{
                breakpoint: 1090,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });


    jQuery(".abrir-busca").click(function () {
        jQuery("#lista-cursos-voalle").hide();
        jQuery("#busca-cursos-voalle").show();
        return false;
    });

    jQuery(".close-search").click(function () {
        jQuery("#lista-cursos-voalle").show();
        jQuery("#busca-cursos-voalle").hide();
        return false;
    });

    jQuery('.second-button').on('click', function () {
        jQuery(`.second-button .animated-icon2`).toggleClass('open');
        jQuery('#menuMobile').toggleClass('open');
        jQuery('.aside-curso').toggleClass('open');
        return false;
    });

    jQuery('#aside-curso-expand').on('click', function (){
        $('#coluna-2').toggleClass('show').css('max-height', $('.arePortal').height()).css('margin-top', 0);
    });

    jQuery('.aside-curso .modulos .modulo').each(function (i) {
        jQuery(this).click(function () {
            jQuery('.aside-curso .modulos .modulosAulaLista').eq(i).stop(true).slideToggle("slow");
        });
    });

    // Modal clear on close
    jQuery('.modal').on('hidden.bs.modal', function () {
        jQuery(this).removeData('bs.modal');
    });

    window.$rateYo = jQuery(".half-star-ratings").rateYo({
        rating: 5,
        halfStar: true
    });

    const swalWithBootstrapButtons = Swal.mixin({});
    var player = [];
    var assistidaSend = false;
    var alterouVelocidade = false;
    if (jQuery(".vimeo-player").length > 0) {
        jQuery(".vimeo-player").each(function (i, obj) {
            player[i] = new Player(jQuery(this), {
                responsive: true
            });
            player[i].value = JSON.parse(this.getAttribute('value'));

            // Cria uma variavel no navegador e adiciona o tempo total do video
            if(!localStorage.hasOwnProperty(`video-${player[i].value.id}-duration`)){
                player[i].getDuration().then(function(duration){
                    localStorage.setItem(`video-${player[i].value.id}-duration`, duration);
                });
            }

            if(player[i].value.reproducao_segundo_plano){
                function videoPause(){
                    player[i].pause();
                }

                function testVisibility() {
                    if (document.visibilityState === 'hidden')
                        videoPause();
                }

                /*visibilitychange:
                    Este evento é acionado com um estado de visibilidade oculto quando
                    um usuário navega para uma nova página, alterna as guias, fecha o
                    guia, minimiza ou fecha o navegador ou, no celular,
                    alterna do navegador para um aplicativo diferente. Transição
                    para oculto é o último evento que é observável de forma confiável por
                    a página, então os desenvolvedores devem tratá-la como o fim provável
                    da sessão do usuário (por exemplo, para enviar dados analíticos).
                */
                document.addEventListener('visibilitychange', testVisibility);

                //blur: It fires when an element (or the document) has lost focus.
                document.addEventListener('blur', videoPause());

                player[i].on("timeupdate", function (data) {
                    if (data.percent >= 0.9) {
                        document.removeEventListener('visibilitychange', testVisibility);
                        document.removeEventListener('blur', videoPause);
                    }
                });

            }

            player[i].on("play", function() {
                if(!localStorage.hasOwnProperty(`inicio-video-${player[i].value.id}`)){
                    window.criaVarTempo(player[i].value.id);
                }

                axios.post(route("ajax.log-reproduzir-video", {
                    aulaItemId: player[i].value.id,
                }, undefined, Ziggy));
            });

            player[i].on("playbackratechange", function (data) {
                player[i].getCurrentTime().then(function (seconds) {
                    // `seconds` indicates the current playback position of the video
                    var min = Math.floor(seconds / 60);
                    var sec = seconds % 60;
                    var tempo = `${min}:${Math.round(sec)}`;

                    axios.post(route("ajax.log-acelerar-video", {
                            aulaItemId: player[i].value.id,
                            tempo: tempo,
                            aceleracao: data.playbackRate
                        }, undefined, Ziggy))
                        .then((response) => {
                            if(response.status == 200 && !alterouVelocidade && data.playbackRate > 1){
                                player[i].getDuration().then(function(duration){
                                    localStorage.setItem(
                                        `video-${player[i].value.id}-duration`,
                                        parseInt(duration) / data.playbackRate
                                    );
                                });

                                alterouVelocidade = true;
                            }
                        });

                });
            });

            player[i].on('loaded', function(){
                $(window).trigger('resize');
            });

            player[i].on("timeupdate", function (data) {
                if (!assistidaSend && data.percent >= 0.9) {
                    assistidaSend = true;
                    // Marca o conteudo como assistido
                    axios.post(route("itemregistro",
                    { aulaItemId: player[i].value.id,
                        cursoModuloAulaId: player[i].value.curso_modulo_aulas_id
                    }))
                    .then(function ( response ) {
                        if (response.data.status == 'ok'){
                            checkAula();
                            axios.post(
                                route("ajax.assistida", {
                                    cursopessoasid: jQuery("#hddCPI").val(),
                                    cursomoduloid: jQuery("#hddCMI").val(),
                                    cursomoduloaulasid: jQuery("#hddCMAI").val(),
                                    cursoid: jQuery("#hddCI").val()
                                }, undefined, Ziggy)
                            );
                        }
                    })
                    .finally(function(){
                        player[i].off('timeupdate');
                        assistidaSend = false;
                    });
                    // verifica se está no inicio do video
                    if(window.verificaTempoUserVideo(player[i].value.id)){
                        window.pontuaAssistirVideoCompleto(
                            player[i].value.id
                        );
                    }
                }

            });
        });
    }

    $('#certificadoPorEmail').on(
        'click',
        function (e) {
            e.preventDefault();
            e.stopPropagation();
            axios.get($(this).prop('href'))
                .then(function () {
                    swalWithBootstrapButtons.fire({
                        text: "Certificado enviado com sucesso!",
                        icon: 'success',
                    });
                })
                .catch(function () {
                    swalWithBootstrapButtons.fire({
                        text: "Não foi possivel enviar o certificado.",
                        icon: 'error',
                    });
                });
        }
    );

    $('#mostraCertificado').click(function () {
        axios.post(route("ajax.acesso.certificado", {
                cursopessoasid: jQuery("#hddCPI").val()
            }, undefined, Ziggy))
            .then(function (response) {
                if (response.data.status && response.data.data.acesso) {
                    window.location.href = response.data.data.link;
                    return true;
                }
                else if(response.data && response.data.deny){
                    uniModalOpen(
                        'W', // type modal
                        'Atenção', // title modal
                        response.data.message, // text body modal
                        'Fechar', // text button
                        function () {
                            uniModalClose();
                        },
                    );

                    return false;
                }

                uniModalOpen(
                    'W', // type modal
                    'Atenção', // title modal
                    'Você precisa avaliar o curso', // text body modal
                    'Fechar', // text button
                    function () {
                        uniModalClose();
                    },
                );

                return false;
            })
            .catch(function () {
                uniModalOpen(
                    'W', // type modal
                    'Atenção', // title modal
                    'Você precisa avaliar o curso', // text body modal
                    'Fechar', // text button
                    function () {
                        uniModalClose();
                    },
                );
                return false;
            });
    });

    if (jQuery("article.aula").length > 0 &&
        (jQuery(".vimeo-player").length == 0 &&
            jQuery(".audio-player").length == 0 &&
            jQuery("#frmAvaliacao").length == 0 &&
            jQuery(".youtubePlayer").length == 0)) {
        checkAula();
        axios.post(route("ajax.assistida", {
                cursopessoasid: jQuery("#hddCPI").val(),
                cursomoduloid: jQuery("#hddCMI").val(),
                cursomoduloaulasid: jQuery("#hddCMAI").val(),
                cursoid: jQuery("#hddCI").val()
            }, undefined, Ziggy))
            .then(function (response) {
                $(`#aulacheck-${modAula}`).text('check_circle').removeClass('text-black').addClass('text-primary');
                verificarAcessoCertificado();
            });
    }

    if (jQuery("#frmAvaliacao").length > 0) {
        let vQuestao = 0;

        jQuery("#stepsProvaQ0").show();
        let qTotal = Number(jQuery("#progressoProva #qTotal").text());
        if (qTotal > 0) {
            vQuestao = 100 / qTotal;
        }

        jQuery("#frmAvaliacao .btn-next").click(function () {
            let questao = Number(jQuery("#progressoProva #qConcluidas").text());
            jQuery("#stepsProvaQ" + (questao - 1)).hide();
            questao += 1
            jQuery("#progressoProva #qConcluidas").text(questao);
            jQuery("#progressoQuestoes").css("width", (questao * vQuestao) + "%");
            jQuery("#progressoQuestoes").attr("aria-valuenow", (questao * vQuestao));
            questao -= 1
            jQuery("#stepsProvaQ" + questao).show();

            var data = new FormData(document.getElementById('frmAvaliacao'));
            data.append('questao_id', this.value)
            axios.post(route("ajax.prova.parcial", undefined, undefined, Ziggy), data)

            let height = $('.areaPortal').height();
            $('#coluna-2').css('max-height', height);

            $("html, body").animate({ scrollTop: 0 }, "slow");
        });

        jQuery("#frmAvaliacao .btn-prev").click(function () {
            let questao = Number(jQuery("#progressoProva #qConcluidas").text());
            jQuery("#stepsProvaQ" + (questao - 1)).hide();
            questao -= 1
            jQuery("#progressoProva #qConcluidas").text((questao));
            jQuery("#progressoQuestoes").css("width", (questao * vQuestao) + "%");
            jQuery("#progressoQuestoes").attr("aria-valuenow", (questao * vQuestao));
            questao -= 1
            jQuery("#stepsProvaQ" + questao).show();

            if (jQuery("#finalizaProvaAdmin").length > 0) {
                jQuery("#finalizaProvaAdmin").prop("disabled", false);
            }

            let height = $('.areaPortal').height();
            $('#coluna-2').css('max-height', height);

            $("html, body").animate({ scrollTop: 0 }, "slow");
        });

        jQuery("#sendExam").click(function () {
            jQuery(this).prop("disabled", true);
            let questao = Number(jQuery("#progressoProva #qConcluidas").text());
            jQuery("#stepsProvaQ" + questao).hide();
            jQuery("#progressoQuestoes").css("width", (questao * vQuestao) + "%");
            jQuery("#progressoQuestoes").attr("aria-valuenow", (questao * vQuestao));
            jQuery("#stepsProvaQ" + questao).show();

            axios.post(route("ajax.prova.processar", undefined, undefined, Ziggy), JSON.stringify(jQuery("#frmAvaliacao").serializeArray()))
                .then(function (response) {
                    if (response && response.status == 200 && response.data && response.data.status && response.data.data) {
                        jQuery("#frmAvaliacao input").each(function () {
                            jQuery(this).prop("disabled", true);
                        });
                        jQuery("#frmAvaliacao textarea").each(function () {
                            jQuery(this).prop("disabled", true);
                        });

                        if (response.data.data.aprovado) {
                            checkAula();
                            verificarAcessoCertificado();
                        }

                        jQuery(".prova").hide();
                        jQuery(".prova_resultado").show();
                        jQuery(".prova_resultado").html(window.atob(response.data.data));

                        refazerAvaliacao();
                        refazerAvaliacaoCorrecao();
                        window.onbeforeunload = null;
                        document.location.reload();

                    } else if (response && response.data && response.data.message) {
                        jQuery('#sendExam').prop("disabled", false);
                        let esconde = Number(jQuery("#progressoProva #qConcluidas").text() - 1)
                        let questao = 1;

                        jQuery("#stepsProvaQ" + esconde).hide();
                        jQuery("#progressoProva #qConcluidas").text(questao);
                        jQuery("#progressoQuestoes").css("width", (questao * vQuestao) + "%");

                        jQuery("#progressoQuestoes").attr("aria-valuenow", (questao * vQuestao));
                        jQuery("#stepsProvaQ" + (questao - 1)).show();
                        $('html, body').animate({
                            scrollTop: 0
                        }, 800);
                        uniModalOpen(
                            'W', // type modal
                            'Atenção', // title modal
                            'Existem questões que não foram respondidas', // text body modal
                            'Fechar', // text button
                            function () {
                                uniModalClose();
                            },
                        );
                    }
                })
                .catch(function (error) {
                    console.error("EXAM", error);
                    swalWithBootstrapButtons.fire({
                        text: error.message,
                        icon: 'error',
                    });
                });
        });

        jQuery("#sendExamReacao").click(function () {
            jQuery(this).prop("disabled", true);
            let questao = Number(jQuery("#progressoProva #qConcluidas").text());
            jQuery("#stepsProvaQ" + questao).hide();
            jQuery("#progressoProva .progress-bar").css("width", (questao * vQuestao) + "%");
            jQuery("#progressoProva .progress-bar").attr("aria-valuenow", (questao * vQuestao));
            jQuery("#stepsProvaQ" + questao).show();

            axios.post(route("ajax.prova.processar-avaliacao-reacao", undefined, undefined, Ziggy), JSON.stringify(jQuery("#frmAvaliacao").serializeArray()))
                .then(function (response) {
                    if (response && response.status == 200 && response.data && response.data.status && response.data.data) {
                        jQuery("#frmAvaliacao input").each(function () {
                            jQuery(this).prop("disabled", true);
                        });
                        jQuery("#frmAvaliacao textarea").each(function () {
                            jQuery(this).prop("disabled", true);
                        });

                        checkAula();
                        verificarAcessoCertificado();

                        jQuery(".questoesReacao").hide();
                        jQuery(".avaliacao_reacao_resultado").show();
                        jQuery(".avaliacao_reacao_resultado").html(window.atob(response.data.data));

                    } else if (response && response.data && response.data.message) {
                        jQuery('#sendExamReacao').prop("disabled", false);
                        let esconde = Number(jQuery("#progressoProva #qConcluidas").text() - 1)
                        let questao = 1;

                        jQuery("#stepsProvaQ" + esconde).hide();
                        jQuery("#progressoProva #qConcluidas").text(questao);
                        jQuery("#progressoProva .progress-bar").css("width", (questao * vQuestao) + "%");
                        jQuery("#progressoProva .progress-bar").attr("aria-valuenow", (questao * vQuestao));
                        jQuery("#stepsProvaQ" + (questao - 1)).show();
                        $('html, body').animate({
                            scrollTop: 0
                        }, 800);
                        uniModalOpen(
                            'W', // type modal
                            'Atenção', // title modal
                            'Existem questões que não foram respondidas', // text body modal
                            'Fechar', // text button
                            function () {
                                uniModalClose();
                            },
                        );
                    }
                })
                .catch(function (error) {
                    console.error("EXAM", error);
                    swalWithBootstrapButtons.fire({
                        text: error.message,
                        icon: 'error',
                    });
                });
        });

        jQuery("#finalizaProvaAdmin").click(function () {
            window.onbeforeunload = null;
            jQuery(this).prop("disabled", true);

            let questao = Number(jQuery("#progressoProva #qConcluidas").text());
            // questao += 1;
            jQuery("#progressoProva #qConcluidas").text(questao);
            jQuery("#progressoProva .progress-bar").css("width", (questao * vQuestao) + "%");
            jQuery("#progressoProva .progress-bar").attr("aria-valuenow", (questao * vQuestao));
        });
    }

    if (jQuery(".audio-player").length > 0) {
        GreenAudioPlayer.init({
            selector: '.audio-player',
            stopOthersOnPlay: true
        });
        jQuery(".audio-player").each(function (item, key) {
            jQuery(this).find("audio").on('ended', function () {
                axios.post(route("itemregistro", {
                        audio: true,
                        aulaItemId: key.attributes.value.nodeValue,
                        cursoModuloAulaId: jQuery("#hddCMAI").val()
                    }))
                    .then(function (response) {
                        if (response.data.status == 'ok') {
                            checkAula();
                            axios.post(route("ajax.assistida", {
                                    audio: true,
                                    cursopessoasid: jQuery("#hddCPI").val(),
                                    cursomoduloid: jQuery("#hddCMI").val(),
                                    cursomoduloaulasid: jQuery("#hddCMAI").val(),
                                    cursoid: jQuery("#hddCI").val()
                                }, undefined, Ziggy))
                                .catch(function (error) {
                                    console.error("AUDIO PLAYER", error);
                                });
                            verificarAcessoCertificado();
                        }
                    });
            });
        });
    }

    function comentarioResposta() {
        $('.addComentario').off();
        $('.addComentario').on('click', function () {
            let comentarioIdPai = $(this).attr('idResposta');
            $('#comentarioRespostaIdPai').val(comentarioIdPai);
            $('#comentarioContainer').modal("show");
        });
    }

    $("#saveComent").click(function () {
        let comentario = $('#txtareaComentarioAula').val();
        let comentarioIdPai = $('#comentarioRespostaIdPai').val();

        if (!comentario.replace(/\s/g, '').length) {
            swalWithBootstrapButtons.fire({
                text: 'Campo vazio: este campo precisa ter algo digitado!',
                icon: 'error',
            });
            $('#comentarioContainer').modal("hide");
        } else {
            axios.post(route("ajax.comentario.salvar", {
                        aulaid: jQuery("#hddCMAI").val(),
                        userid: jQuery("#hddUID").val()
                    },
                    undefined, Ziggy), {
                    comentario: comentario,
                    comentarioidpai: comentarioIdPai
                })
                .then(function (response) {
                    if (response && response.status == 200 && response.data && response.data.status) {
                        $('#txtareaComentarioAula').val('');
                        let com = response.data.data;
                        let data = new Date(com.created_at);
                        let dd = String(data.getDate()).padStart(2, '0');
                        let mm = String(data.getMonth() + 1).padStart(2, '0');
                        let yyyy = data.getFullYear();
                        let dataCerta = `${dd}/${mm}/${yyyy}`;

                        if (com.avatar === null) {
                            com.avatar = `${window.location.origin}/storage/avatar/imagem_padrao.png`
                        }
                        let blocoComentario = '#idBlocoComentario';
                        if (comentarioIdPai) {
                            blocoComentario = `#comentarioResposta-${comentarioIdPai}`;
                            $(`.botaoResposta-${comentarioIdPai}`).hide();
                        }
                        let registroComentario = `<div class="post-container" id="idcomentario-${com.id}">
                        <img src="${com.avatar}" alt="user" class="profile-photo-md float-left">
                        <div class="post-detail">
                            <div class="user-info">
                                <h5>${com.nome}</h5>
                                <p class="text-muted">${dataCerta}</p>
                            </div>
                            <div class="line-divider"></div>
                            <div class="post-text">
                                <p>${com.comentario}<i class="em em-anguished"></i><i class="em em-anguished"></i><i class="em em-anguished"></i></p>
                            </div>
                        </div>
                        <button id="${com.id}"  class="excluirComentario btn btn-primary px-4 rounded-pill">Excluir</button>
                    </div>`;

                        $(blocoComentario).prepend(registroComentario);
                        let val = parseInt($('#numComentAulas').html());
                        $('#numComentAulas').html(++val);
                        excluirComentario();
                        comentarioResposta();
                        $('#comentarioRespostaIdPai').val('');

                        swalWithBootstrapButtons.fire({
                            text: response.data.message,
                            icon: 'success',
                        });
                        $('#comentarioContainer').modal("hide");
                    } else if (response && response.data && response.data.message) {
                        swalWithBootstrapButtons.fire({
                            text: response.data.message,
                            icon: 'error',
                        });
                        $('#comentarioContainer').modal("hide");
                    }
                })
                .catch(function (error) {
                    swalWithBootstrapButtons.fire({
                        text: error.message,
                        icon: 'error',
                    });
                });
        }
    });

    excluirComentario();
    refazerAvaliacao();
    refazerAvaliacaoCorrecao();

    //card-carrossel
    var carouselHome = jQuery(".carrossel-home-item").height();

    menuCurso()
    menuFixo()
    $(window).scroll(function () {
        menuCurso()
        menuFixo()
    });
    $(window).on('resize', function () {});

    function menuCurso() {
        var valorDes = 200
        $(".menuCurso a").each(function (i) {
            $(".menuCurso a").eq(i).click(function () {
                $(".menuCurso a").removeClass("ativo");
                $(".menuCurso a").eq(i).addClass("ativo");
                var dataLink = $(this).attr("data-id");
                $('html, body').stop(true).animate({
                    scrollTop: $("#" + dataLink).offset().top - valorDes
                }, 800);

            });
        });
    }

    function menuFixo() {
        var scrollPagina = $(window).scrollTop();
        if (scrollPagina > 500) {
            $(".menuCurso").addClass("aberto");
            $(".menuCursoBloco").addClass("aberto");
            $(".menuCursoNone").addClass("aberto");
        } else {
            $(".menuCurso").removeClass("aberto");
            $(".menuCursoBloco").removeClass("aberto");
            $(".menuCursoNone").removeClass("aberto");
        }
    }

    function modal(route, size) {
        let modal = '#modalAjax' + (size ? size : '');
        modal = $(modal);
        axios.get(route)
            .then(function (response) {
                modal.find('.modal-content').html(response.data);
                if (!modal.find('.modal-content:visible').length) {
                    modal.modal('show');
                }
            });
    }

    $(document).on('click', '.link-avaliacoes', function (e) {
        let elemento = $(this),
            curso = elemento.data('curso'),
            pessoa = elemento.data('pessoa');

        modal(
            route(
                "ajax.instrutores.avaliacoes.avaliacoes", {
                    curso: curso,
                    pessoa: pessoa,
                },
                undefined,
                Ziggy
            ),
            'Lg'
        );
    });

    $(document).on('click', '.link-avaliacoes-analistas', function (e) {
        let elemento = $(e.target),
            curso = elemento.data('curso'),
            pessoa = elemento.data('pessoa');
        modal(
            route(
                "ajax.analistas.avaliacoes", {
                    curso: curso,
                    pessoa: pessoa,
                },
                undefined,
                Ziggy
            ),
            'Lg'
        );
    });

    $(document).on('click', '.btn-aula', function () {
        let elemento = $(this);

        modal(
            route(
                "ajax.instrutores.avaliacoes.avaliacao", {
                    aula: elemento.data('aula'),
                    curso: elemento.data('curso'),
                    pessoa: elemento.data('pessoa'),
                },
                undefined,
                Ziggy
            ),
            'Xl'
        );
    });

    /* Text Area Counter Set Start */
    $(document).on('keyup', '#mensagemDuvida', function (event) {
        checkTextAreaMaxLength(this, event);
    });



    $(document).on('keyup', '.char-textarea', function (event) {
        checkTextAreaMaxLength(this, event);
        // to later change text color in dark layout
        $(this).addClass('active');
    });

    /*
    Checks the MaxLength of the Textarea
    -----------------------------------------------------
    @prerequisite:
    textBox = textarea dom element
    e = textarea event
    length = Max length of characters
    */
    function checkTextAreaMaxLength(textBox, e) {
        let maxLength = parseInt($(textBox).data('length')),
            // counterValue = $(textBox).parent().find('.textarea-counter-value'),
            charTextarea = $(textBox);

        if (!checkSpecialKeys(e) && (textBox.value.length < maxLength - 1)) {
            textBox.value = textBox.value.substring(0, maxLength);
        }
        $(textBox).parent().find('.char-count').html(textBox.value.length);

        if (textBox.value.length > maxLength) {
            // counterValue.css('background-color', '#EA5455');
            // charTextarea.css('color', '#4e5154');
            charTextarea.addClass('max-limit');
        } else {
            // counterValue.css('background-color', '#7367F0');
            charTextarea.css('color', '#4e5154');
            charTextarea.removeClass('max-limit');
        }

        return true;
    }

    /*
    Checks if the keyCode pressed is inside special chars
    -------------------------------------------------------
    @prerequisite:  e = e.keyCode object for the key pressed
    */
    function checkSpecialKeys(e) {
        return !(e.keyCode !== 8 && e.keyCode !== 46 && e.keyCode !== 37 && e.keyCode !== 38 && e.keyCode !== 39 && e.keyCode !== 40);
    }

    function formatData(dataItem) {
        let data = new Date(dataItem);
        let dd = String(data.getDate()).padStart(2, '0');
        let mm = String(data.getMonth() + 1).padStart(2, '0');
        let yyyy = data.getFullYear();
        return `${dd}/${mm}/${yyyy}`;
    }

    $('#loadComentario').click(function () {
        let isto = $(this);
        let idUltimoComentario = isto.data('idcomentario');
        let idPessoa = isto.data('idpessoa');
        let idAula = isto.data('idcma');

        axios.get(route("ajax.comentario.buscar-mais", {
                    aulaid: idAula,
                    comentarioid: idUltimoComentario
                },
                undefined,
                Ziggy))
            .then(function (response) {
                if (response && response.status == 200 && response.data && response.data.status) {
                    let comentarios = response.data.data;
                    if (comentarios.length == 0) {
                        isto.html('Não há mais comentários')
                    }
                    comentarios.forEach(function (com) {
                        if (com.pessoa.avatar === null) {
                            com.pessoa.avatar = `${window.location.origin}/storage/avatar/imagem_padrao.png`
                        }
                        let dataCerta = formatData(com.created_at);
                        let blocoComentario = '#idBlocoComentario';

                        let registroFilho = '';
                        com.respostas.forEach(function (resp, idx, array) {
                            if (resp.pessoa.avatar === null) {
                                resp.pessoa.avatar = `${window.location.origin}/storage/avatar/imagem_padrao.png`
                            }
                            let dataCertaResp = formatData(resp.created_at);

                            let remRespComentario = '';
                            if (idPessoa === resp.pessoa_id && idx === 0) {
                                remRespComentario = `<button id="${resp.id}" class="botaoResposta-${com.id} excluirComentario btn btn-primary px-4 rounded-pill">Excluir</button>`;
                            } else if (idPessoa !== resp.pessoa_id && idPessoa === com.pessoa_id && idx === 0) {
                                remRespComentario = `<button idResposta="${com.id}" class="botaoResposta-${com.id} addComentario btn btn-primary px-4 rounded-pill">Responder</button>`;
                            }

                            registroFilho += `
                                <div class="post-container" id="idcomentario-${resp.id}">
                                    <img src="${resp.pessoa.avatar}" alt="user" class="profile-photo-md float-left">
                                        <div class="post-detail">
                                            <div class="user-info">
                                                <h5>
                                                    ${resp.nome}
                                                </h5>
                                                <p class="text-muted">${dataCertaResp}</p>
                                            </div>
                                            <div class="line-divider"></div>
                                            <div class="post-text">
                                                <p>${resp.comentario} <i class="em em-anguished"></i> <i
                                                    class="em em-anguished"></i> <i class="em em-anguished"></i>
                                                </p>
                                            </div>
                                        </div>
                                        ${remRespComentario}
                                </div>`;
                        });

                        let botaoExcluir = '';
                        if (idPessoa === com.pessoa_id && com.respostas.length === 0) {
                            botaoExcluir = `<button id="${com.id}"  class="excluirComentario btn btn-primary px-4 rounded-pill">Excluir</button>`;
                        }

                        let registroComentario = `<div class="post-container" id="idcomentario-${com.id}">
                            <img src="${com.pessoa.avatar}" alt="user" class="profile-photo-md float-left">
                            <div class="post-detail">
                                <div class="user-info">
                                    <h5>${com.nome}</h5>
                                    <p class="text-muted">${dataCerta}</p>
                                </div>
                                <div class="line-divider"></div>
                                <div class="post-text">
                                    <p>${com.comentario}<i class="em em-anguished"></i><i class="em em-anguished"></i><i class="em em-anguished"></i></p>
                                    <div id="comentarioResposta-${com.id}">
                                        ${registroFilho}
                                    </div>
                                </div>
                            </div>
                            ${botaoExcluir}
                        </div>`;
                        isto.data('idcomentario', com.id)
                        $(blocoComentario).append(registroComentario);
                        excluirComentario();
                        comentarioResposta();

                    });

                } else if (response && response.data && response.data.message) {
                    swalWithBootstrapButtons.fire({
                        text: response.data.message,
                        icon: 'error',
                    });
                }
            })
            .catch(function (error) {
                swalWithBootstrapButtons.fire({
                    text: error.message,
                    icon: 'error',
                });
            });
    });

        window.tutorial_gamificacao = function (arr,interacao){
            axios.get(route("ajax.gamificacao.verifica.visto", {
                interacao: interacao
            }, undefined, Ziggy))
            .then(function(response){
                if(response.status === 200){
                    if(response.data){
                       var $newdiv1 = $(`<div id="tutoGamificacaoContainer" class="modal fade text-center show tutoGamif" tabindex="-1" role="dialog" aria-labelledby="modalDicasGamificacao" style="letter-spacing: 1px; display: none; padding-left: 0px;" aria-modal="true">
                <div class="modal-dialog modal-dialog-centered modal-md" role="document" style="width: 344px;">
                    <div class="modal-content br-3">
                        <div class="tutoGamif modal-header justify-content-center text-center" style="border-radius: 3px 3px 0px 0px !important;">
                        <script src="https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js"></script>
                        <lottie-player src="https://assets4.lottiefiles.com/packages/lf20_au98facn.json"  background="transparent"  speed="1"  style="width: 300px; height: 200px;"  loop  autoplay></lottie-player>

                        </div>
                        <div class="modal-body bg-tutorial pb-0">
                            <div class="row">
                                <div class="col-md-12">

                                    <div class="space-between" id="bx-interacao-tutorial">
                                        <div class="m-1 text-grey-2" style="text-align: left;">
                                        <div class="uni-label-medium conhecTutoGamif">#conhecimento</div>

                                        <div class="mt-3">
                                        <div class="uni-title-medium titTutoGamif">Uma plataforma feita para você!</div>
                                            <div class="mt-3">
                                                <div class="contentTutoGamif uni-body-medium" id="contnt-interacao-tutorial"></div>
                                            </div>
                                        </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex rodapeTutoGamif"><div class="m-3 mt-2" style="border-top: 0px !important;" id="btns-interacao-tutorial"></div></div>
                    </div>
                </div>
            </div> `);
                        $( "body" ).append( $newdiv1);

                        $('#tutoGamificacaoContainer').modal("show");
                        var retn = response.data;
                        arr.forEach((i,n)=>{
                            var frase_btn; var onclk_func; var btn;
                            if(arr.length == (n+1)){
                                //Entendi
                                btn = `<button type="button" class="btn-tutorial border-btn-tutorial uni-label-large" onclick="$('#tutoGamificacaoContainer').modal('hide');concluirInteracaoTutorial('`+interacao+`');">Entendi</button>`;
                            }else{
                                //Próximo
                                btn = `<button type="button" class="btn-tutorial border-btn-tutorial uni-label-large" onclick="btn_show('btn-interacao-tutorial-`+(n+1)+`','btn-interacao-tutorial');btn_show('interacao-tutorial-`+(n+1)+`','interacao-tutorial')">Avançar</button>`;
                                btn += `<button type="button" class="btn-tutorial uni-label-large" data-dismiss="modal" aria-label="Close" onclick="$('#tutoGamificacaoContainer').modal('hide');concluirInteracaoTutorial('`+interacao+`');">Pular</button>`;

                            }
                            $("#contnt-interacao-tutorial").append('<div style="display:none;" id="interacao-tutorial-'+n+'" class="interacao-tutorial"><div>'+i+'</div></div>');
                            $("#btns-interacao-tutorial").append('<div style="display:none;" id="btn-interacao-tutorial-'+n+'" class="btn-interacao-tutorial">'+btn+'</div>');

                            if(arr.length == (n+1)){
                                btn_show('interacao-tutorial-0','interacao-tutorial');
                                btn_show('btn-interacao-tutorial-0','btn-interacao-tutorial');
                            }
                        });
                    }
                }
            })
         }

         window.dicasAvatarGamificadoAleatorias = function (){
            axios.get(route("ajax.gamificacao.verifica_login_dicas", undefined, undefined, Ziggy))
            .then(function(response){
                if(response.data.length > 0){
                    axios.get(route("ajax.gamificacao.notificacoes_personagem", undefined, undefined, Ziggy))
                    .then(function(response){
                        if(response.status === 200){
                            var retn = response.data;
                            if(retn.length > 0 && document.getElementById("tutoGamificacaoContainer") == null){
                                var index =  Math.floor(Math.random() * retn.length - 1);
                                var notif = retn[index];
                                var i = notif.notificacao;
                                var $newdiv1 = $('<div style="relative;"><div class="dicasGamif bx-dicas-gamif" id="object-dicas" style="transition: transform 2s ease 0s;transform: translateX(800px);"></div></div>' );
                                $( "body" ).append( $newdiv1);
                                $("#object-dicas").append(`
                                <div class="d-flex flex-row justify-content-between p-3 h-auto">
                                    <div id="mascote-dicas-div">
                                        <div style="float:right;margin-right: 10px;">
                                            <div style="width:80px;">
                                                <div id="container-img-dica">
                                                    <div id="circle-loader-wrap">
                                                        <div class="left-wrap">
                                                            <div class="loader"></div>
                                                        </div>
                                                        <div class="right-wrap">
                                                            <div class="loader"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="float:left;font-size: 13px;margin-left: 2%;" id="bx-interacao-dicas"></div>
                                    <div><span id="fecha-dica" style="cursor: pointer;"  class="material-symbols-outlined">close</span></div>
                                </div>`)
                                $("#bx-interacao-dicas").append('<div style="position: relative;max-width: 500px;" class="interacao-dicas"><div>'+i+'</div></div>');
                                axios.get(route("ajax.gamificacao.UpdateLoginDicas", undefined, undefined, Ziggy));

                                var f = document.getElementById('object-dicas');
                                setTimeout(()=>{
                                    f.style.transform = 'translateX(-20px)';
                                    setTimeout(()=>{
                                        f.style.transform = 'translateX(800px)';
                                    },10000)
                                },500);

                                $("#fecha-dica").on("click", function(){
                                    setTimeout(()=>{
                                        f.style.transform = 'translateX(800px)';
                                    },500);
                                });
                            }
                        }
                    })
                }
            }).catch(function(e){
                console.error(e);
            });
         }



        window.notificationAvatarGamificadoPontuou = function (i){
            $("#bx-notf-avtar").remove();
            var clsDark = '';
            if(darkMode == 1){
                clsDark = 'modarkPontuaGamif';
            }
            var $newdiv1 = $(`
            <div class="${clsDark}" id="bx-notf-avtar">
                <div id="object-pontuou"
                    style="position:fixed;z-index: 999999;display:block;right:40px;bottom:350px;transition: transform 2s ease 0s;transform: translateY(1000px);">
                </div>
            </div>`);
            $( "body" ).append( $newdiv1);

            $("#object-pontuou").append(`
            <div style="position: relative;height: 100%;display: table-caption;border-radius:10px;z-index:10;">
                <div class="d-flex flex-row justify-content-between" style="position:relative;z-index:10;">
                    <div id="container-pontuacao">
                        <div id="circle-loader-wrap">
                            <div class="left-wrap">
                                <div class="loader"></div>
                            </div>
                            <div class="right-wrap">
                                <div class="loader"></div>
                            </div>
                        </div>
                        <div id="bx-interacao-pontuou">
                        </div>
                    </div>
                </div>
            </div>`)

            $("#bx-interacao-pontuou").append(`
                <div style="position: relative;padding: 12px;" class="interacao-pontuou">
                    <div class="text-notf-pontuou">
                        <div style="font-size:32px;font-weight:600; color: #000 !important">
                            <span class="moreString" style="color: #000 !important">+</span>`+i+`
                        </div>
                        <div style="font-size:10px;font-weight:400;padding-left: 8px;margin-top: -10px; color: #000 !important">Ponto(s)</div>
                    </div>
                </div>
            `);

            setTimeout(()=>{
                var f = document.getElementById('object-pontuou');
                f.style.transform = 'translateY(-10px)';
                setTimeout(()=>{
                    f.style.transform = 'translateY(1000px)';
                },8000)
            },500)
        }

        $('#global-search').click(function(){
            $(this).addClass('hidden');
            $('#search-input').removeClass('hidden').addClass('show');

            setTimeout(function() {
                $('#search-text').focus();
            }, 10);
        });

        var searchInput = document.getElementById('search-text');
        var cancelIcon = document.querySelector('#search-input .cancel-icon');

        if(searchInput) {
            searchInput.addEventListener('input', function() {
                if (searchInput.value.trim() !== '') {
                    cancelIcon.classList.remove('hidden');
                } else {
                    cancelIcon.classList.add('hidden');
                }
            });
        }

        if (cancelIcon) {
            cancelIcon.addEventListener('click', function() {
                searchInput.value = '';
                cancelIcon.classList.add('hidden');
                $('#search-input').removeClass('show').addClass('hidden');
                $('#global-search').removeClass('hidden').addClass('show');
            });
        }
});

